import { defineComponent, openBlock, createBlock, createVNode, pushScopeId, popScopeId, resolveComponent, withScopeId, withCtx, renderSlot, toDisplayString, TransitionGroup, Fragment, createCommentVNode } from 'vue';
import { mapState } from 'vuex';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var script = defineComponent({
  name: 'brace'
});

var _hoisted_1 = {
  class: "brace"
};

var _hoisted_2 = /*#__PURE__*/createVNode("span", {
  class: "brace-tr"
}, " ", -1);

var _hoisted_3 = /*#__PURE__*/createVNode("span", {
  class: "brace-tl"
}, " ", -1);

var _hoisted_4 = /*#__PURE__*/createVNode("span", {
  class: "brace-bl"
}, " ", -1);

var _hoisted_5 = /*#__PURE__*/createVNode("span", {
  class: "brace-br"
}, " ", -1);

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _hoisted_4, _hoisted_5]);
}

script.render = render;

var script$1 = defineComponent({
  name: 'loadingSpinner'
});

var _hoisted_1$1 = {
  class: "loading-spinner"
};

var _hoisted_2$1 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_3$1 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_4$1 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_5$1 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_6 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_7 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_8 = /*#__PURE__*/createVNode("span", null, null, -1);

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$1, [_hoisted_2$1, _hoisted_3$1, _hoisted_4$1, _hoisted_5$1, _hoisted_6, _hoisted_7, _hoisted_8]);
}

script$1.render = render$1;

var script$2 = defineComponent({
  name: "loadingModal",
  components: {
    loadingSpinner: script$1
  }
});

var _withId = /*#__PURE__*/withScopeId("data-v-5ef2bfb9");

pushScopeId("data-v-5ef2bfb9");

var _hoisted_1$2 = {
  class: "box"
};
var _hoisted_2$2 = {
  class: "media is-vcentered"
};
var _hoisted_3$2 = {
  class: "media-left"
};

var _hoisted_4$2 = /*#__PURE__*/createVNode("div", {
  class: "media-content has-text-centered"
}, [/*#__PURE__*/createVNode("h3", null, "Loading, please wait...")], -1);

popScopeId();

var render$2 = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_loading_spinner = resolveComponent("loading-spinner");

  var _component_modal = resolveComponent("modal");

  return openBlock(), createBlock(_component_modal, {
    "hide-close": ""
  }, {
    default: _withId(function () {
      return [createVNode("div", _hoisted_1$2, [createVNode("div", _hoisted_2$2, [createVNode("figure", _hoisted_3$2, [createVNode(_component_loading_spinner)]), _hoisted_4$2])])];
    }),
    _: 1
  });
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "\n.media-left[data-v-5ef2bfb9] {\r\n    margin-bottom: 0 !important;\n}\n.media-content[data-v-5ef2bfb9] {\r\n    overflow: visible;\n}\r\n";
styleInject(css_248z);

script$2.render = render$2;
script$2.__scopeId = "data-v-5ef2bfb9";

var script$3 = defineComponent({
  name: 'loading'
});

var _hoisted_1$3 = {
  class: "loading"
};

var _hoisted_2$3 = /*#__PURE__*/createVNode("div", null, [/*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span")], -1);

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$3, [_hoisted_2$3]);
}

script$3.render = render$3;

var script$4 = defineComponent({
  name: 'modal-card',
  props: {
    active: {
      type: Boolean,
      required: true
    }
  }
});

var _hoisted_1$4 = {
  class: "modal-card-head"
};
var _hoisted_2$4 = {
  class: "modal-card-title"
};
var _hoisted_3$3 = {
  class: "modal-card-body"
};
var _hoisted_4$3 = {
  class: "modal-card-foot"
};
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_modal = resolveComponent("modal");

  return openBlock(), createBlock(_component_modal, {
    class: "is-card",
    active: _ctx.active
  }, {
    default: withCtx(function () {
      return [createVNode("header", _hoisted_1$4, [createVNode("p", _hoisted_2$4, [renderSlot(_ctx.$slots, "title")])]), createVNode("section", _hoisted_3$3, [renderSlot(_ctx.$slots, "body")]), createVNode("footer", _hoisted_4$3, [renderSlot(_ctx.$slots, "foot")])];
    }),
    _: 3
  }, 8, ["active"]);
}

script$4.render = render$4;

var script$5 = defineComponent({
  name: "modal-dialog",
  components: {
    modalCard: script$4
  },
  props: {
    isSave: Boolean,
    active: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    buttonLabel: function buttonLabel() {
      return this.isSave ? "Save" : "Proceed";
    }
  },
  methods: {
    proceed: function proceed() {
      this.$emit("done", true);
    },
    cancel: function cancel() {
      this.$emit("done", false);
    }
  }
});

var _hoisted_1$5 = {
  class: "buttons"
};
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_modal_card = resolveComponent("modal-card");

  return openBlock(), createBlock(_component_modal_card, {
    active: _ctx.active
  }, {
    title: withCtx(function () {
      return [renderSlot(_ctx.$slots, "title")];
    }),
    body: withCtx(function () {
      return [renderSlot(_ctx.$slots, "body")];
    }),
    foot: withCtx(function () {
      return [createVNode("div", _hoisted_1$5, [createVNode("button", {
        type: "button",
        class: "is-success",
        onClick: _cache[1] || (_cache[1] = function () {
          return _ctx.proceed && _ctx.proceed.apply(_ctx, arguments);
        })
      }, toDisplayString(_ctx.buttonLabel), 1), createVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = function () {
          return _ctx.cancel && _ctx.cancel.apply(_ctx, arguments);
        })
      }, "Cancel")])];
    }),
    _: 1
  }, 8, ["active"]);
}

script$5.render = render$5;

var script$6 = defineComponent({
  name: "homeMenuItem",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
});

var _withId$1 = /*#__PURE__*/withScopeId("data-v-46a74a5b");

pushScopeId("data-v-46a74a5b");

var _hoisted_1$6 = {
  class: "media"
};
var _hoisted_2$5 = {
  class: "media-left"
};
var _hoisted_3$4 = {
  class: "icon is-large has-text-info"
};
var _hoisted_4$4 = {
  class: "media-content"
};
var _hoisted_5$2 = {
  class: "content"
};
var _hoisted_6$1 = {
  class: "title is-4"
};
var _hoisted_7$1 = {
  class: "subtitle"
};

popScopeId();

var render$6 = /*#__PURE__*/_withId$1(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = resolveComponent("router-link");

  return openBlock(), createBlock(_component_router_link, {
    class: "box",
    to: _ctx.url
  }, {
    default: _withId$1(function () {
      return [createVNode("article", _hoisted_1$6, [createVNode("div", _hoisted_2$5, [createVNode("span", _hoisted_3$4, [createVNode("i", {
        class: ["fa-2x", _ctx.icon]
      }, null, 2)])]), createVNode("div", _hoisted_4$4, [createVNode("div", _hoisted_5$2, [createVNode("h4", _hoisted_6$1, toDisplayString(_ctx.title), 1), createVNode("p", _hoisted_7$1, toDisplayString(_ctx.subtitle), 1)])])])];
    }),
    _: 1
  }, 8, ["to"]);
});

var css_248z$1 = "\r\n/* bulma media-content with child tags results in vertical overflow \r\n  Bulma github issue: https://github.com/jgthms/bulma/issues/1428\r\n*/\n@media screen and (max-width: 768px) {\n.media-content[data-v-46a74a5b] {\r\n    overflow-x: unset;\n}\n}\r\n";
styleInject(css_248z$1);

script$6.render = render$6;
script$6.__scopeId = "data-v-46a74a5b";

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  brace: script,
  loadingModal: script$2,
  loadingSpinner: script$1,
  loading: script$3,
  modalCard: script$4,
  modalDialog: script$5,
  homeMenuItem: script$6
});

var script$7 = defineComponent({
  name: 'modal',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      docHtml: document.querySelector('html').classList,
      bodyActive: false,
      _active: this.active
    };
  },
  computed: {},
  watch: {
    active: function active(newVal) {
      this.set_active(newVal);
    }
  },
  methods: {
    set_active: function set_active(val) {
      var that = this;

      if (val) {
        this._active = true;
        this.docHtml.add('is-clipped');
        this.$nextTick(function () {
          return that.bodyActive = true;
        });
      } else {
        this.bodyActive = false;
        setTimeout(function () {
          that._active = false;
          that.docHtml.remove('is-clipped');
        }, 500);
      }
    }
  },
  mounted: function mounted() {
    this.set_active(this.active);
  }
});

var _hoisted_1$7 = {
  key: 0,
  class: "modal is-active"
};

var _hoisted_2$6 = /*#__PURE__*/createVNode("div", {
  class: "modal-background",
  key: "modal-background"
}, null, -1);

var _hoisted_3$5 = {
  class: "modal-body",
  key: "modal-body"
};
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx._active ? (openBlock(), createBlock("div", _hoisted_1$7, [createVNode(TransitionGroup, {
    name: "modal"
  }, {
    default: withCtx(function () {
      return [_ctx.bodyActive ? (openBlock(), createBlock(Fragment, {
        key: 0
      }, [_hoisted_2$6, createVNode("div", _hoisted_3$5, [renderSlot(_ctx.$slots, "default")])], 64)) : createCommentVNode("", true)];
    }),
    _: 1
  })])) : createCommentVNode("", true);
}

script$7.render = render$7;

var installOnApp = function installOnApp(app, name, fn) {
  app.config.globalProperties[name] = fn;
  app.provide(name, fn);
};

var plugin = {
  install: function install(app) {
    app.component(script$7.name, script$7);
    installOnApp(app, '$closeModal', closeModal);
  }
};

var closeModal = function closeModal(callback) {
  setTimeout(callback, 750);
};

var state = function state() {
  return {};
};

var getters = {};
var mutations = {};
var actions = {};
var store = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  plugin: plugin,
  store: store
});

var states = {
  hard: 'hard',
  soft: 'soft',
  done: null
};
states.default = states.done;

var state$1 = function state() {
  return {
    loading: states.default
  };
};

var getters$1 = {};
var mutations$1 = {
  loading: function loading(s, val) {
    s.loading = val;
  }
};
var actions$1 = {};
var store$1 = {
  namespaced: true,
  state: state$1,
  getters: getters$1,
  mutations: mutations$1,
  actions: actions$1
};

var script$8 = defineComponent({
  name: "loadingManager",
  components: {
    loading: script$3,
    loadingModal: script$2
  },
  data: function data() {
    return {
      soft: states.soft,
      hard: states.hard,
      loadingState: states.default,
      modalActive: false
    };
  },
  computed: _objectSpread2({}, mapState("loadingManager", ["loading"])),
  watch: {
    loading: function loading(newVal) {
      if (!newVal || newVal === states.done) {
        this.modalActive = false;
        return;
      }

      if (newVal === states.hard) this.modalActive = true;
      this.updateLoadingState();
    }
  },
  methods: {
    updateLoadingState: function updateLoadingState() {
      this.loadingState = this.loading;
    }
  }
});

function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_loading = resolveComponent("loading");

  var _component_loading_modal = resolveComponent("loading-modal");

  return openBlock(), createBlock(Fragment, null, [_ctx.loadingState === _ctx.soft ? (openBlock(), createBlock(_component_loading, {
    key: 0
  })) : createCommentVNode("", true), createVNode(_component_loading_modal, {
    active: _ctx.modalActive
  }, null, 8, ["active"])], 64);
}

script$8.render = render$8;

var plugin$1 = {
  install: function install(app, options) {
    if (!options) throw 'Options are required to install plugin';
    app.component(script$8.name, script$8);
    var store = options.store;
    installOnApp(app, '$hardLoading', function () {
      return hardLoading(store);
    });
    installOnApp(app, '$softLoading', function () {
      return softLoading(store);
    });
    installOnApp(app, '$doneLoading', function () {
      return doneLoading(store);
    });
  }
};

var setState = function setState(store, val) {
  store.commit('loadingManager/loading', val);
};

var hardLoading = function hardLoading(store) {
  setState(store, states.hard);
};

var softLoading = function softLoading(store) {
  setState(store, states.soft);
};

var doneLoading = function doneLoading(store) {
  setState(store, states.done);
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  plugin: plugin$1,
  store: store$1
});

var install = function installVueAml(app) {
  Object.entries(components).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        componentName = _ref2[0],
        component = _ref2[1];

    app.component(componentName, component);
  });
}; // Create module definition for Vue.use()

export default install;
export { script as brace, script$6 as homeMenuItem, script$3 as loading, index$1 as loadingManager, script$2 as loadingModal, script$1 as loadingSpinner, index as modal, script$4 as modalCard, script$5 as modalDialog };
